import { strings } from './BookSizeSelector.strings'
import { ListBox, ListOption } from '@/ui/components'
import { BookSizes, bookFormats } from '@/ui/pages/PreviewPDF/createPdf/PdfBook'
import { FormattedMessage } from 'react-intl'

const labelMap: Record<BookSizes, React.ReactElement> = {
  'large-square': <FormattedMessage {...strings['large-square']} />,
  'medium-square': <FormattedMessage {...strings['medium-square']} />,
  'small-square': <FormattedMessage {...strings['small-square']} />,
  'large-rectangle': <FormattedMessage {...strings['large-rectangle']} />,
  'medium-rectangle': <FormattedMessage {...strings['medium-rectangle']} />,
  'small-rectangle': <FormattedMessage {...strings['small-rectangle']} />,
  'xsmall-rectangle': <FormattedMessage {...strings['xsmall-rectangle']} />,
}

const bookOptions = Object.entries(bookFormats).map(([key]) => ({
  id: key,
  label: labelMap[key as BookSizes],
  value: key,
}))

interface Props {
  onSelect: (selected: ListOption) => void
}

export const BookSizeSelector: React.FC<Props> = (props) => {
  return (
    <ListBox
      label={<FormattedMessage {...strings.bookSize} />}
      options={bookOptions}
      onSelect={props.onSelect}
    />
  )
}
